module.exports = __webpack_public_path__ + "img/ledger-city-logo.a8d67eea.png";